var xhr, scheduled = false, _throttleDelay = 200, $body, $modal, $secondaryModal, bb_status = getCookie('BB_STATUS'), resizeThrottleDelay, $window,clickevent='click',skrollr,refered;
var editorExtensionId = "cfhjhmphknppmdadefofodicemlogjmn";


$(document).ready(function () {
    
    $body = $('body'); 
    $window = $(window);
    $body.find('img').addClass('onErrorCallbak');
    $body.find('img').on('error', missingImageLoad);
  

	$('.account-sidebar-trigger').click(function(){
		$('body').toggleClass('show-account-sidebar');
		return false;
	});	
	$('.account-nav-mobile-sidebar-overlay, .account-nav-mobile-sidebar .close-nav').click(function(){
		$('body').removeClass('show-account-sidebar');
		return false;
	});
    
	if ("ontouchstart" in window || navigator.msMaxTouchPoints)
    {
        $('body').addClass('touch');
    } else {
        $('body').addClass('no-touch');
    }   
	
	$('.burger-btn,.account-sidebar-trigger,.dropdown-toggle').click(function(e){		
		$('body.search-visible').removeClass('search-visible');
		$('body.show-account-sidebar').removeClass('show-account-sidebar');
        //e.preventDefault();
	});
	
	$('.header .topnav .help-center').click(function(){
		//$('.header .topnav .help-center-content').toggleClass('open');
		//return false;
	});
	$('.responsive-content .help-center').click(function(){
		$('.responsive-nav .responsive-content').toggleClass('show-help-center');
		return false;
	});

	$('.dropdown_trigger').click(function(){
		if(!$(this).parent().hasClass('open')){

			$('.page-link.open').removeClass('open');
			$(this).parent().addClass('open');
            //$(this).parent().find("img").lazyload();	 		
			/*try {
				$(this).parent().find("img").lazyload();
			}
			catch(err) {
				$(this).parent().find("img").each(function(){
					var $this = $(this);
					$this.attr('src', $this.data('src'));
				});
			}*/

            if($('.heroes').length>0 && $('header').data('transparent')){
                var _scrollTop = $(window).scrollTop();
                var _hero = 100;
                if( Number(_scrollTop) < Number(_hero) ){
                    $('header').removeClass('transparent');
                }
            } 
			
		}else{
			$('.page-link.open').removeClass('open');

            if($('.heroes').length>0 && $('header').data('transparent')){
                var _scrollTop = $(window).scrollTop();
                var _hero = 100;
                if( Number(_scrollTop) < Number(_hero) ){
                    $('header').addClass('transparent');
                }
            }
			$(this).blur();
		}
		return false;
	});
	
	
	

	$(document).click(function(event) { 
		if(!$(event.target).closest('.dropdown-menu').length) {
			if($('.page-link.open').length>0) {
				$('.page-link.open').removeClass('open');
                if($('.heroes').length>0 && $('header').data('transparent')){
                    var _scrollTop = $(window).scrollTop();
                    var _hero = 100;
                    if( Number(_scrollTop) < Number(_hero) ){
                        $('header').addClass('transparent');
                    }
                }
			}
		}        
	});
	
	if($('.heroes').length>0 && $('header').data('transparent')){
		var _scrollTop = $(window).scrollTop();
		var _hero = 100;
		$('header').addClass('transparent');
		if( Number(_scrollTop) > Number(_hero) ){
			$('header').removeClass('transparent');
		}
		$(document).on('scroll',function() {
			_scrollTop = $(window).scrollTop();
			if( Number(_scrollTop) > Number(_hero) ){
				$('header').removeClass('transparent');
			}else{
				$('header').addClass('transparent');	
			}	
		});
	}
	
	
	
	$('.responsive-nav .categories-nav .toggle').click(function(){
		var _this = $(this);
		
		if(_this.parent().hasClass('open')){
			$('.responsive-nav .categories-nav li.open').removeClass('open');
		}else{
			$('.responsive-nav .categories-nav li.open').removeClass('open');
			_this.parent().addClass('open');	
		}
		
	});
	
	
	$('.burger-btn').click(function($e){
		$('body').toggleClass('show-menu');
        $e.preventDefault();
	});
	
	$('.account-sidebar-trigger').click(function($e){
		$('body').toggleClass('show-account-sidebar');
                $e.preventDefault();

	});

    $body.append('<div class="modal fade" id="modalSecondary" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"></div>');
    $body.append('<div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"></div>');

    $modal = $('#modal');
    $secondaryModal = $('#modalSecondary');

    $(document).on('ifToggled','.toggle-select-all', function(event){
        var target = $(this).data('toggleSelectAllTarget');
        $(target).each(function () {
            $(this).iCheck('toggle');
        });
    });

    $(document).on('ifChecked','.select-all', function(event){
        var target = $(this).data('selectAllTarget');
        $(target).each(function () {
            $(this).iCheck('uncheck');
        });
        $(this).iCheck('disable');
    });
    $(document).on('click','.update-library-stats-toggle',function(){
        $(this).closest('.upgrade-modal-body').find('.toggleable').toggleClass('hidden');
        $(this).find('span').toggleClass('hidden');
    });

    $(document).on('click','.resend-activation-email',function(){
        $.ajax({data: {module: 'customers', 'action': 'resend-activation-email'}, success: function (data) {
            if (data.status == 'ok') {
                form_submit_response('', 'success', data.message, true);
            } else if (data.status == 'error') {
                form_submit_response('form[name="login_form"]', 'error', data.error);
            } else {
                form_submit_response('form[name="login_form"]', 'error', 'An unknown error occurred. Please try again later');
            }
        }
        });
        return false;
    });
	
    $(document).on('click','a[data-target="#search-collapsible"]',function(){
        GA.register('button','click','search');
        scroll2position(0);
        setTimeout(function(){
            $('input[name="search_param"]').focus();
        },500);
    });

    $(document).on('click','.section-library-details .details-link',function(e){
        e.preventDefault();
        return false;
    });

    $(document).on('click','header.header .navbar-nav li > a, .details-link',function(){
        if($(this).parent().hasClass('single-video-item-related') && $body.hasClass('section-library-details')){
            return false;
        }
        var h = $(this).attr('href');

        if(h.indexOf(URL ) == 0 && !$(this).hasClass('no-ajax')){
            ajaxNavigation(h,'test title',true,'#wrap');
            return false;
        }
    });

    $modal.on('hidden.bs.modal', function (e) {
        $(this).empty();

    });

    $(document).on('click', '.scroll-to-element', function (e) {
        scroll2element($(this).attr('href'));
        e.preventDefault();
    });

    $(document).on('click', '.close-collapsible', function () {
        $(this).closest('.in').find('input:text').val('');
        $(this).closest('.in').collapse('hide');
        return false;
    });

    $(document).on('click', '.collapse-all', function () {
        $('.panel-collapse').collapse('hide');
        $(this).toggle();
        $('.expand-all').toggle();
        return false;
    });

    $(document).on('click', '.expand-all', function () {
        $(this).toggle();
        $('.collapse-all').toggle();
        $('.panel-collapse').collapse('show');
        return false;
    });


    $(document).on('click',function(){
        if( $('.perspective').hasClass('animate') ) {
            setTimeout(hideMenu,300);
        }
    });

    $(document).on('click', '.navbar-toggle', function () {
        if( $('.perspective').hasClass('animate') ) {
            hideMenu();
        }else{
            revealMenu('left');
        }
        return false;
    });
   

    $(document).on('click', '.delete-address', function () {

        var id = $(this).data('id');
        confirm_overwrite('Are you sure you want to remove that address?', function () {
            $.ajax({data: {module: 'addresses', 'action': 'del-address', id: id}, success: function (data) {
                if (data.status == 'ok') {
                    form_submit_response('.my_account_content', 'success', data.message, true);
                } else if (data.status == 'error') {
                    form_submit_response('.my_account_content', 'error', data.error);
                } else {
                    form_submit_response('.my_account_content', 'error', 'An unknown error occurred. Please try again later');
                }
            }
            });
        }, 'OK');
    });
 
    /*$(document).on('click', "a[data-toggle='modal'][data-type='ajax'] , button[data-toggle='modal'][data-type='ajax']", function (e) {
     try{
     e.preventDefault();
     //openAjaxModal($(this).attr('href'));
     }catch(Error){
     console.log(Error);
     }

     return false;
     });
     */
    $(document).on('click', ".ajax-modal", function (e) {
        try{
            e.preventDefault();
            openAjaxModal($(this).attr('href'));
        }catch(Error){
            console.log(Error);
        }

        return false;
    });
    $(document).on('click', ".inline-modal", function (e) {

        e.preventDefault();
        var t = $(this).data('href');
        var markup = $(t).clone();
        $modal.removeData('bs.modal');

        $('#modal').html(markup).find(t).show();
        skinFormElements('#modal');
        $modal.modal('show');
        return false;
    });

    $(document).on('click', '[data-action="submit"]', function () {
        var target = $(this).data('target');
        $('form[name="'+target+'"]').submit();
        return false;
    });
    $(document).on('click', '[data-action="submit-with-target"]', function () {
        var target = $(this).data('target');
        $(target).submit();
        return false;
    });
    $(document).on('click', '.scroll-top', function () {
        scroll2position(0);
        return false;
    });

    $(document).on('click','.filters .update-results',function(){


        var target = $(this).data('target'),container = $(this).closest('.filters-content');

        container.find('.filter-group').each(function(){
            var k = $(this).data('filterGroup');
            var key = 'attributes['+k+']';
            if(k == 'cid'){
                key = 'cid';
            }else if(k == 'not_purchased'){
                key = 'not_purchased';
            }

            if(k == 'not_purchased'){
                $('form[name="' + target + '-nav"] input[name="' + key + '"]').remove();
            }else{
                $('form[name="' + target + '-nav"] input[name="' + key + '[]"]').remove();
            }


            $(this).find('input:checkbox:checked,input:hidden.hidden-filter').each(function(){
                var value = $(this).val();
                if(value!=''){
                    var values = value.split(',');
                    for(var i in values){
                        if(k == 'not_purchased'){
                            $('form[name="' + target + '-nav"]').append('<input type="hidden" name="' + key + '" value="' + values[i] + '"/>');
                        }else{
                            $('form[name="' + target + '-nav"]').append('<input type="hidden" name="' + key + '[]" value="' + values[i] + '"/>');
                        }

                    }

                }

            });
        });

        $('.filters .reset-filters').removeClass('hidden');

        setTimeout(function(){
            deepLinking(target);
            filter(target);
        },500);

        return false;
    });
    $(document).on('click','.filters .reset-filters a',function(){
        var target = $(this).data('target');
        $('.filters input:checkbox').each(function(){
            if($(this).hasClass('select-all')){
                $(this).iCheck('check');
            }else{
                $(this).iCheck('uncheck');
            }
            var value = $(this).val();
            var key = $(this).closest('.filter-group').data('filterGroup');

            if(value!=''){
                var values = value.split(',');
                for(var i in values){
                    var value = values[i];
                    $('form[name="' + target + '-nav"] input:hidden[name="' + key + '[]"][value="'+value+'"]').remove();
                    $('form[name="' + target + '-nav"] input:hidden[name="attributes[' + key + '][]"][value="'+value+'"]').remove();
                }

            }
        });
        $('.filters .reset-filters').addClass('hidden');
        // history.pushState(true, '' , '');
        deepLinking(target);
        filter(target);
        return false;
    });
    $(document).on('click', 'button.filter', function (e) {
        var key = $(this).data('filterName'),
            target = $(this).data('target'),
            value = $(this).data('value'),
            label = $(this).text(),
            multiple = $(this).data('multiple');

        if($(this).hasClass('active')){
            return false;
        }

        $('form[name="' + target + '-nav"] input[name="' + key + '"]').val(value);
        $('.filter[data-filter-name="' + key + '"]').removeClass('active');
        $(this).addClass('active');
        filter(target);
        scroll2element($(this));
        e.preventDefault();
    });

    $(document).on('click', 'a.filter', function (e) {
        var key = $(this).data('filterName'),
            target = $(this).data('target'),
            value = $(this).data('value'),
            label = $(this).text(),
            multiple = $(this).data('multiple');

        if($(this).closest('li').hasClass('active') || $(this).hasClass('active')){
            return false;
        }

        if (multiple == true) {

            if ($(this).parent().hasClass('active')) {
                // it's already checked. Uncheck it please
                $(this).parent().removeClass('active');
                $('form[name="' + target + '-nav"] input[name="' + key + '[]"][value="' + value + '"]').remove();

            } else if (value == '') {
                $('a.filter[data-filter-name="' + key + '"]').parent().removeClass('active');
                $('form[name="' + target + '-nav"] input[name="' + key + '[]"]').remove();
            } else {
                // Not checked
                $(this).parent().addClass('active');
                $('form[name="' + target + '-nav"]').append('<input type="hidden" name="' + key + '[]" value="' + value + '"/>');
            }
        } else {
            $('.filter[data-filter-name="' + key + '"]').parent().removeClass('active');
            $(this).parent().addClass('active');
            var t = $(this).closest('.filter-group').find('.current-filter-value');
            if(value!==''){
                t.html(label);
            }else if(value===''){
                t.html(t.data('default'));
            }

            $('form[name="' + target + '-nav"] input[name="' + key + '"]').val(value);
        }

        if(key == 'sort_term'){
            if(value!==''){
                $(this).closest('ul').find('.reset').removeClass('hidden');
                $(this).closest('ul').find('.reset').next().removeClass('hidden');
            }else{
                $(this).closest('ul').find('.reset').addClass('hidden');
                $(this).closest('ul').find('.reset').next().addClass('hidden');
            }

            GA.register('Filters','Sort',value);

            $('form[name="' + target + '-nav"] input[name="sort_way"]').val($(this).data('defaultSortWay'));

            if($(this).data('type') == 'numeric'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-numeric-'+current_sort_term).show();
                $('.toggle-sort-way').data('type','numeric');
            }else if($(this).data('type') == 'alpha'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-alpha-'+current_sort_term).show();
                $('.toggle-sort-way').data('type','alpha');
            }else if($(this).data('type') == 'amount'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-amount-'+current_sort_term).show();
                $('.toggle-sort-way').data('type','amount');
            }else if($(this).data('type') == 'custom'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-custom-'+current_sort_term).show();
                $('.toggle-sort-way').data('type','custom');
            }else if($(this).data('type') == 'custom-numeric'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-custom-numeric-'+current_sort_term).show();
                $('.toggle-sort-way').data('type','custom-numeric');
            }


        }else if(key == 'list-size'){
            GA.register('Filters','List Size',value);

            if($body.hasClass('section-collections')){
                setCookie('COLLECTIONS_LIST_SIZE', value);
            }else if($body.hasClass('section-collection-details')){
                setCookie('VIDEOS_LIST_SIZE', value);
            }
        }



        deepLinking(target);
        filter(target);

        e.preventDefault();
    });

  
    $(document).on('click', '.toggle-sort-way', function () {
        var target = $(this).data('target');
        if ($('form[name="' + target + '-nav"] input[name="sort_way"]').val() == 'DESC') {
            $('form[name="' + target + '-nav"] input[name="sort_way"]').val('ASC');

            if($(this).data('type') == 'numeric'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-numeric-'+current_sort_term).show();
            }else if($(this).data('type') == 'alpha'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-alpha-'+current_sort_term).show();
            }else if($(this).data('type') == 'amount'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-amount-'+current_sort_term).show();
            }else if($(this).data('type') == 'custom'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-custom-'+current_sort_term).show();
            }else if($(this).data('type') == 'custom-numeric'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-custom-numeric-'+current_sort_term).show();
            }

        } else {

            $('form[name="' + target + '-nav"] input[name="sort_way"]').val('DESC');
            if($(this).data('type') == 'numeric'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-numeric-'+current_sort_term).show();
            }else if($(this).data('type') == 'alpha'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-alpha-'+current_sort_term).show();
            }else if($(this).data('type') == 'amount'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-amount-'+current_sort_term).show();
            }else if($(this).data('type') == 'custom'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-custom-'+current_sort_term).show();
            }else if($(this).data('type') == 'custom-numeric'){
                var current_sort_term = $('form[name="' + target + '-nav"] input[name="sort_way"]').val().toLowerCase();
                $('.toggle-sort-way > .fa,.toggle-sort-way > span').hide();
                $('.toggle-sort-way .fa-sort-custom-numeric-'+current_sort_term).show();
            }

        }
        if($('form[name="' + target + '-nav"] input[name="action"]').val() == 'search-products'){
            $('form[name="' + target + '-nav"] input[name="found-single-video"]').val(0);
            $('form[name="' + target + '-nav"] input[name="found-collection"]').val(0);
            $('form[name="' + target + '-nav"] input[name="found-library"]').val(0);
        }
        deepLinking(target);
        filter(target);
        return false;
    });

    $(document).on('click', '.filter-reset', function (e) {
        var key = $(this).data('filterName');
        var value = $(this).data('filterValue');
        var target = $(this).data('target');

        $('form[name="' + target + '-nav"] input[name="' + key + '"]').val(value);
        $('.filter[data-filter-name="' + key + '"]').parent().removeClass("active");
        $('.filter-reset').hide();
        $('.filter-label').hide();
        deepLinking(target);
        filter(target);
        e.preventDefault();
    });

    $(document).on('click','[data-action="filter"]',function(){
        var p = $(this).closest('.partial'), page = $(this).data('page');
        p.data('page',page);
        p.addClass('loading');
        load_partial(p);
        return false;
    });


    init();
    skinFormElements();
    waypoints();   

    $('.partial[data-async="1"]').each(function(){
        load_partial( $(this), function(c){   
             c.imagesLoaded( {},
                 function() {                    
                    waypoints(c);                    
                }
            ); 
            
        });
    });
    $('body').addClass('loaded');
});


function waypoints(){       
    $('.way-point:not(.way-point-ready)').each(function(){
        $(this).waypoint(function() {
            $(this.element).addClass('shown');
        }, {
            offset: '90%'
        }); 
        $(this).addClass('way-point-ready');       
    });
    
}

function refineURL(){

    var currURL = window.location.href; //get current address       
    var beforeQueryString = currURL.split("?")[0];      
    return beforeQueryString;     
}
function openAjaxModal(href,$mm){

    $m = $mm || $modal;
 
    $m.removeData('bs.modal');
    $m.empty();
    $m.load(href,function(){
        $m.modal('show');
        skinFormElements('#'+$m.attr('id'));
    });
}

function init( target ){
 
    var t = (typeof(target)!=='undefined') ? target : 'body';   

     $(t).find('[data-action="load-more"]').on('click',function($e){

        var partial = $(this).closest('.partial'),
            page    = partial.data('page'),
            caller  = $(this);
            
        if(page == null || page < 1){
            page = 1;
        }
        partial.data('page', page + 1);
        caller.data('text',caller.text());
        caller.text('WORKING ON IT');
        
        append_partial(partial,function(){
            
            if(PCKRY){
                PCKRY.packery('reloadItems');
                $('#galleriesGrid').imagesLoaded( {},
                     function() {
                        $('#galleriesGrid .item').addClass('loaded');
                        PCKRY = $('#galleriesGrid').packery({

                            itemSelector: '.item',
                            gutter: 0
                        });
                    }
                ); 
            }
            caller.remove();                         
        });

        $e.preventDefault();

    });
}
function skinFormElements(target){   
    var t = typeof(target)!=='undefined' ? target : 'body';

    $(t).find('.show-pass').click(function(){
        var _this = $(this),
            input = _this.closest('.form-group').find('input'),
            type = input.attr('type');
        if(type === 'password'){
            input.attr("type", "text");
            $(this).html(_this.data('label-hide'));     
        }else{
            input.attr("type", "password");
            $(this).html(_this.data('label-show'));
        }
    });	

    
    $(t).find('select.select2').each(function(){
        $(this).select2($(this).data()).on('select2:open', function () {
            $(this).closest('.form-group').addClass('filled');
            $('.select2-dropdown').closest('.select2-container').addClass('z-index-dropdown');
        }).on('select2:close', function () {
            if( $(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null ){
                $(this).closest('.form-group').removeClass('filled');
            }            
            $('.select2-dropdown').closest('.select2-container').removeClass('z-index-dropdown'); 
        });
    });    
    $(t).find('select.select2-no-search').each(function(){
        $(this).select2({ minimumResultsForSearch: -1}).on('select2:open', function () {
            $(this).closest('.form-group').addClass('filled');
            $('.select2-dropdown').closest('.select2-container').addClass('z-index-dropdown');
        }).on('select2:close', function () {
            if( $(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null ){
                $(this).closest('.form-group').removeClass('filled');
            }            
            $('.select2-dropdown').closest('.select2-container').removeClass('z-index-dropdown'); 
        });
    }); 
    
    $(t).find(".form-control" ).focusin(function() {
        $(this).parent().addClass('filled');
    });

    $(t).find(".form-control" ).focusout(function() {
        if($(this).val() === "" ){
            $(this).parent().removeClass('filled');
        }
    });
    
	/* 
	try {
		$(t).find("img.lazyload").lazyload();
	}
	catch(err) {
		$(t).find("img.lazyload").each(function(){
			var $this = $(this);
			$this.attr('src', $this.data('src'));
		});
	}*/
    
    topFilters.init();    
    
}



function actionResponseModal(msg,type,container){
	var $timeout = 0;
	
	if($('body').hasClass('modal-open') ){
		$('.modal').modal('hide');
		$timeout = 300;	
	}
	setTimeout(function(){
		var _container = container || '';
		if(type == 'success'){
			var icon = '<i class="fa fa-check-circle" aria-hidden="true"></i>';	
		}else{
			var icon = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i>';	
		}
		var content = '<div class="alert alert-'+type+'"><span>'+icon+' '+msg+'</span></div>'
		$('#responseModal .modal-body').html(content);	
		$('body').addClass('dark-backdrop');
		$('#responseModal').modal('show');
		$('#responseModal').on('hidden.bs.modal', function () {
			$('#responseModal .modal-body').empty();
			$('body').removeClass('dark-backdrop');
		});
	},$timeout);
}

function prepareItems() {
    $('.item img').each(function () {
        var w = $(this).closest('.item').outerWidth() / $(this).data('ratio');

        $(this).height(w);
    });
}
function initFilters(){
    $('.side-filters .collapse').on('shown.bs.collapse', function () {

        setTimeout(function(){
            sideBarScroll.refresh();
            skinFormElements('#filters-collapsible');
        },1)
    });

    $('.side-filters .collapse').on('hidden.bs.collapse', function () {
        sideBarScroll.refresh();
    });
    $('body').addClass('filters-menu-expanded');
}

function equalizeHeight(target){
    var min_height = 0;
    setTimeout(function(){
        $( target).each(function(){
            if($(this).outerHeight() > min_height){
                min_height = $(this).outerHeight();
            }
        });
        if(min_height>0){
            $(target).css('min-height',min_height);
        }
    },500);
}